//CRM_routes.js
// File Name: routes.js
// Version: 0.03
// NOTE: Update the version number each time changes are made to this file.

// Import necessary modules for routing
import React, { useState } from 'react';
import { Routes, Route, useLocation, Navigate  } from 'react-router-dom';

import Login from './pages/Login/Login';
import UserProfile from './pages/UserProfile/UserProfile';
import Layout from './components/layout/Layout';
import DashboardRouter from './components/DashboardRouter';

// Reseller full-page routes
import CrmPage from './pages/Dashboard/reseller/CrmPage';
import OrgPage from './pages/Dashboard/reseller/OrgPage';
import InvoicingPage from './pages/Dashboard/reseller/InvoicingPage';

// Function for AppRoutes
function AppRoutes() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';
  const [user, setUser] = useState(null);

  return (
    <Layout showNavigation={!isLoginPage}>
      <Routes>
        <Route path="/" element={ user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />} />
        <Route path="/profile" element={<UserProfile user={user} setUser={setUser} />} />
        <Route path="/dashboard" element={<DashboardRouter user={user} />} />

        {/* Reseller Full Pages */}
        <Route path="/dashboard/resellers/crm" element={<CrmPage />} />
        <Route path="/dashboard/resellers/org" element={<OrgPage />} />
        <Route path="/dashboard/resellers/invoicing" element={<InvoicingPage />} />
      </Routes>
    </Layout>
  );
}

export default AppRoutes;
